import { createContext, useContext, ReactNode } from 'react';

import { StepperContext } from '@treezor/design-system';

export interface ICardUnitCreationContext {
  currentStep: number;
  setCurrentStep: (step: number) => void;
  nextStep: () => void;
  prevStep: () => void;
  onClose: () => void;
}

export const CardUnitCreationContext = createContext<ICardUnitCreationContext>({} as ICardUnitCreationContext);

interface ICardUnitCreationProvider {
  onClose: () => void;
  children: ReactNode;
}

export function CardUnitCreationProvider({ onClose, children }: ICardUnitCreationProvider) {
  const { currentStep, nextStep, prevStep, setActiveStep } = useContext(StepperContext);

  return (
    <CardUnitCreationContext.Provider
      value={{
        onClose,
        currentStep,
        setCurrentStep: setActiveStep,
        nextStep,
        prevStep,
      }}
    >
      {children}
    </CardUnitCreationContext.Provider>
  );
}

export const useCardUnitCreationContext = () => useContext(CardUnitCreationContext);
